module.exports = __webpack_public_path__ + "static/media/shk.fbace249.jpg";